import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { ReceiptTemplateFormParamList } from "../../../../types";
import ReceiptTemplateType from "../../../../utilities/data/model/ReceiptTemplateType";
import React from "react";
import { Q } from "@nozbe/watermelondb";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import { useTranslation } from "react-i18next";
import {
  FlatActionList,
  FlatActionListItem,
  Page,
} from "@towersystems/roam-common-native";
import { useFormContext } from "react-hook-form";
import { ReceiptTemplateFormValues } from "../../components/ReceiptTemplateForm";

export type SelectTemplateStyleScreenProps = NativeStackScreenProps<
  ReceiptTemplateFormParamList,
  "SelectTemplateStyleScreen"
>;

const options = [
  {
    label: "Thermal",
    value: "thermal",
    description: "A thermal receipt template.",
  },
  {
    label: "A4",
    value: "a4",
    description: "A4 receipt template.",
  },
];

export const SelectTemplateStyleScreen = ({
  navigation,
}: SelectTemplateStyleScreenProps) => {
  const { t } = useTranslation("settings");
  const { watch, setValue } = useFormContext<ReceiptTemplateFormValues>();
  const watchedTemplateStyleId = watch("defaultTemplateType");

  const items: FlatActionListItem[] = React.useMemo(() => {
    return options.map((option) => ({
      id: option.value,
      key: option.value,
      title: option.label,
      subTitle: option.description,

      onPress: () => {
        setValue("defaultTemplateType", option.value, {
          shouldValidate: true,
          shouldDirty: true,
        });
        navigation.goBack();
      },
      selected: watchedTemplateStyleId === option.value,
    }));
  }, []);

  return (
    <Page title={t("modal_select_paytype_title")}>
      <FlatActionList items={items} />
    </Page>
  );
};
